import React from "react"
import styled from "@emotion/styled"
import cx from "classnames"

import { convertContentStackAsset } from "../../utils"

import VideoCover from "react-video-cover"
import { parseContentstackComponent } from "../../parseUtils"

import "./component.scss"

const Component = props => {
  const videoOptions = {
    src: props.background_image,
    autoplay: "true",
    loop: true,
    muted: true,
    remeasureonwindowresize: "true",
  }

  const Component = styled.div`
    position: relative;

    .component__background {
      top: 0;
      bottom: 0;
      position: absolute;
      z-index: -1;

      ${!props.background_image
        ? `background-color: ${props.background_color};`
        : `
      background-position: center;
      background-size: cover;
      `}
    }

    ${props.count % 2 === 0 &&
    props.typename === "Contentstack_half_width_component_wrapper"
      ? `.component__background {
      right: 50%;
      left: 0;
      margin-right: -50vw;
      margin-right: 0;
      width: 50vw;
    }
  }

  .text-block {
    padding-left: 97px;
  } 

  @media screen and (min-width: 992px) and (max-width: 1200px) {   
    .text-block {
      padding-left: 35px;

      h2 {
        font-size: 57px;
      }
    } 
  }
  `
      : ` 
  .component__background {
    right: 0;
    left: 100%;
    margin-left: -50vw;
    margin-right: 0;
    width: 50vw;
  }

    .text-block {
      padding-right: 77px;
    }
    @media screen and (min-width: 992px) and (max-width: 1200px) {
      .text-block {
        h2 {
          font-size: 57px;
        }
        padding-right: 0px;
        
        .body-copy {
          padding-right: 30px;
        }
      }
    }
  `}

    @media (max-width: 991px) {
      .component__background {
        width: 100vw;
        right: 50%;
        left: 50%;
        margin-left: -50vw;
        margin-right: -50vw;
      }

      .text-block {
        padding-left: 0;
        padding-right: 0;
      }
    }
  `

  let lazyLoadBackground = false

  if (
    props.__typename !== "Contentstack_hero" &&
    props.background_image !== false
  ) {
    lazyLoadBackground = true
  }

  return (
    <Component
      className={cx("component", {
        "half-height":
          props.component_height !== undefined &&
          props.component_height === "half height",
        "full-height":
          props.component_height === undefined ||
          props.component_height === "full height",
        "half-width":
          props.typename === "Contentstack_half_width_component_wrapper",
        "full-width":
          props.typename !== "Contentstack_half_width_component_wrapper",
      })}
    >
      <div
        className={cx("component__background", {
          lazyload: lazyLoadBackground !== false,
        })}
        style={{
          backgroundImage:
            !lazyLoadBackground && props.background_image
              ? `url(${convertContentStackAsset(
                  `${props.background_image}?quality=80`
                )})`
              : "none",
        }}
        data-bg={
          lazyLoadBackground && props.background_image
            ? convertContentStackAsset(`${props.background_image}?quality=80`)
            : "none"
        }
      />
      {props.__typename === "Contentstack_hero" &&
        props.background_type === "video/mp4" && (
          <div className="hero__video">
            <VideoCover videoOptions={videoOptions} />
          </div>
        )}
      {parseContentstackComponent(props)}
    </Component>
  )
}

export default Component
